import { useState } from "react";
import { useContext, useEffect } from "react";
import { FaSearch } from "react-icons/fa";
import { SidebarContext } from "../../context/SidebarContext";
import { MdOutlineMenu } from "react-icons/md";
import { Button } from "@mui/material";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { get, patch } from "../../config/axios";
import Loading from "../Loading/index";
import ApiIntegrationModal from "./ApiIntegrationModal";
import "./ApiIntegration.css";
import { useSelector } from "react-redux";

const ApiIntegrationPage = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userIntegrationsData, setUserIntegrationsData] = useState([]);
  const [apiKey, setApiKey] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  // const token = useSelector((store) => store.userReducer.token);
  const role = useSelector((store) => store.userReducer.role);

  // const handleSearch = (event) => {
  //   setSearchQuery(event.target.value.toLowerCase());
  // };

  const { openSidebar } = useContext(SidebarContext);

  const fetchUserIntegrations = async () => {
    setIsLoading(true);
    try {
      const response = await get(`/v1/admin/users/integrations`);

      setUserIntegrationsData(response?.data);
    } catch (error) {
      console.log(error.message);
    }

    setIsLoading(false);
  };

  const rotateApiKey = async (item) => {
    if (role === "super") {
      try {
        // const response = await patch(
        //   `/v1/admin/users/rotate/${item?.user?.id}`
        // );
        // // const response = await rotateKey(token, item?.user?.id);
        // setApiKey(response?.apiKey);
      } catch (error) {
        console.log(error.message);
      }
    } else {
      let body = {
        user: item.user,
      };
      try {
        const response = await patch(`/v1/admin/users/rotate`, body);
        setApiKey(response?.apiKey);
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  // const rotateApiKey = async (item) => {
  //   try {

  //     let response;

  //     if(role === 'super')
  //       response = await rotateKey(token, item?.user?.id);

  //     else response = await rotateUserKey(token,)

  //     setApiKey(response?.apiKey);

  //   } catch(err) {
  //     console.log(err.message);
  //     throw err;
  //   }
  // }

  useEffect(() => {


    fetchUserIntegrations();
  }, []);

  const handleOpenModal = (item) => {
    rotateApiKey(item)
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="content-area">
      <div className="area-top-l">
        <button
          className="sidebar-open-btn"
          type="button"
          onClick={openSidebar}
        >
          <MdOutlineMenu size={24} />
        </button>
        <h2 className="area-top-title">API Integration</h2>
      </div>
      {/* <div>
        <div className="search-bar">
          <input
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={handleSearch}
          />
          <FaSearch className="search-icon" />
        </div>
      </div> */}
      <div className="search-divs-manage">
        <div className="search">
          <input
            type="text"
            className="search-input-user-management"
            placeholder="Search"
            // onChange={handleChange}
          />
          <FaSearch className="search-icon-user-management" />
        </div>
      </div>
      {isLoading ? (
        <Loading />
      ) : (
        userIntegrationsData?.map((item, index) => {
          // console.log("wqqqwqwqwqwqwq", item);
          if (
            searchQuery.length === 0 ||
            item?.user?.name.toLowerCase().includes(searchQuery)
          ) {
            return (
              <div className="card" key={index}>
                <div className="user-info">
                  <div className="left-section">
                    <p className="question">User Name</p>
                    <p className="answer">{item?.user?.name}</p>
                    <p className="question">Secret Key</p>
                    <p className="answer">*********</p>
                  </div>
                  <div className="right-section">
                    <p className="question">User ID</p>
                    <p className="answer">{item?.user?.id}</p>


                    <Button
                      variant="outlined"
                      endIcon={<AutorenewIcon sx={{ color: "inherit" }} />}
                      sx={{
                        "&:hover": {
                          backgroundColor: "#0051B7",
                          color: "white",
                          "& .MuiSvgIcon-root": {
                            color: "white",
                          },
                        },
                      }}
                      onClick={() => handleOpenModal(item)}
                    >
                      Rotate Key
                    </Button>

                  </div>
                </div>
              </div>
            );
          } else {
            return null;
          }
        })
      )}

      <ApiIntegrationModal
        open={isModalOpen}
        handleClose={handleCloseModal}
        apiKey={apiKey}
      />
    </div>
  );
};

export default ApiIntegrationPage;
